import React, { useState, useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useModal } from '@panel/commons/hooks';
import { site } from '@panel/commons/helpers';
import { Step } from './step';
import { stepsConfig, useStepperCtx } from './steppercontex';
import { StepperContainer, StepWrapper } from './styles';
import { getStepperState } from '../../ducks/stepper';
import { Modal } from '../Modals/ModalWrapper';
import { SaveChangeForm } from '../Modals/saveChangeForm';
import { LeavePaymentForm } from '../Modals/leavePaymentForm';
import { isPaymentScreen } from '../../utils/path';
import { Headband } from '../headband';

const siteId = site.id;

function StepperList() {
  const [hasStepper, setHasStepper] = useState(true);
  const { lastStep, lastModule } = useSelector(getStepperState);
  const {
    currentStep,
    currentModule,
    preventTransition,
    setPreventTransition,
    setNextStepperRoute,
    nextStepperRoute,
    stepperFormRef
  } = useStepperCtx();
  const { isShowing, toggleValue } = useModal();
  const location = useLocation();
  const { push } = useHistory();

  useEffect(() => {
    if (location.pathname.includes('/status') || location.pathname.includes('/servicios')) {
      setHasStepper(false);
    } else {
      setHasStepper(true);
    }
  }, [location]);

  useEffect(() => {
    setNextStepperRoute(null);
    setPreventTransition(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentStep, currentModule]);

  const formatPath = stepId => {
    const [stepToGo] = Object.values(stepsConfig).filter(item => stepId === item.id);
    return stepToGo.path;
  };

  const handleRedirect = path => {
    const idPost = new URLSearchParams(location.search).get('postingId');
    push(`${path}${idPost ? `?postingId=${idPost}` : ''}`);
  };

  const handleOpenModal = stepId => {
    const path = formatPath(stepId);
    setNextStepperRoute(path);
    toggleValue(true);
  };

  const handleModalClose = () => {
    toggleValue(false);
  };

  const handleModalRedirect = () => {
    handleModalClose();
    setPreventTransition(null);
    handleRedirect(nextStepperRoute);
  };

  const isEnabled = ({ step, module }) => step < lastStep || (step === lastStep && module <= lastModule);

  return (
    <>
      {hasStepper && (
        <StepperContainer data-repa='stepperList-container'>
          {siteId === 'VAMX' && <Headband />}
          <StepWrapper>
            {Object.values(stepsConfig).map(({ id, title, path, enabledStep }) => (
              <Step
                key={id}
                id={id}
                title={title}
                path={path}
                currentStep={currentStep}
                isEnabled={isEnabled(enabledStep)}
                handleRedirect={() => handleRedirect(formatPath(id))}
                preventTransition={preventTransition}
                handleOpenModal={handleOpenModal}
              />
            ))}
          </StepWrapper>
        </StepperContainer>
      )}
      {isShowing && !isPaymentScreen(location.pathname) && (
        <Modal data-repa='stepperList-modal'>
          <SaveChangeForm
            openModal={isShowing}
            onClose={handleModalClose}
            handleRedirect={handleModalRedirect}
            formRef={stepperFormRef}
          />
        </Modal>
      )}
      {isShowing && isPaymentScreen(location.pathname) && (
        <Modal>
          <LeavePaymentForm openModal={isShowing} onClose={handleModalClose} handleRedirect={handleModalRedirect} />
        </Modal>
      )}
    </>
  );
}

export { StepperList };
